/* eslint-disable */
import React, { useRef, useEffect, useState } from 'react'

import { readCookie, getLanguageMeta } from 'AccountsUtils'

import { ViewContainer } from '../../../newComponents/UnifiedLogin'

import useModal from '../../../newComponents/SupportPage/useModal'

import { Login } from '../../../newComponents/Login'
import { isInFlyinDomain } from 'AccountsUtils'

// const useOutsideAlerter = (ref) => {
//   /**
//    * Alert if clicked on outside of element
//    */
// }

const LoggedoutProfileDropdown = ({ hideProfileDropdown }) => {
  const { isShowing, toggle } = useModal()
  const [page, setPageName] = useState(null)
  const wrapperRef = useRef(null)
  const { locale } = getLanguageMeta()
  const showUnifiedLogin = locale === 'IN'

  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if (!isShowing) {
        hideProfileDropdown()
      }
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })
  const signin = () => {
    if (showUnifiedLogin) {
      setPageName('SIGNIN')
      toggle()
    } else {
      window.location.href = '/signin'
    }
  }
  const handleIsShowing = () => {
    setPageName('SIGNIN')
    toggle()
  }

  return (
    <>
      <ul
        ref={wrapperRef}
        className="listMenu userAccountMenu loggedOut"
        id="userAccountMenu"
      >
        <li className="clearFix">
          <ul>
            <li className="signInBlock">
              <input
                onClick={signin}
                type="submit"
                title="Sign In"
                value="Sign In"
                className="primary large"
                tabIndex="11"
                id="SignIn"
              />
              <p>
                New here?{' '}
                <a
                  // href="/register?service=/visa/dubai"
                  href="#"
                  className="weak"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                  onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (showUnifiedLogin) {
                      setPageName('SIGNIN')
                      toggle()
                    } else {
                      window.location.href = '/register?service=/visa/dubai'
                    }
                  }}
                >
                  Register
                </a>
              </p>
            </li>
            <li className="userAccountCol accountTools">
              <ul>
                <li>
                  <a
                    href={
                      isInFlyinDomain()
                        ? '/accounts/trips?src=qtct&amp;sub_src=trips&amp;chnl=Fly'
                        : '/accounts/trips?src=qtct&amp;sub_src=trips'
                    }
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoTrips">&nbsp;</i>
                    Trips
                  </a>
                </li>
                <li>
                  <a
                    href="/account/travellers?src=qtct&amp;sub_src=travellers"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoTravellers">&nbsp;</i>
                    Travellers
                  </a>
                </li>
                <li className="separator" />
                <li>
                  <a
                    href="/accounts/wallet?src=qtct&amp;sub_src=wallet"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoWallet">&nbsp;</i>
                    Wallet
                  </a>
                </li>
                <li>
                  <a
                    href="/accounts/expressway?src=qtct&amp;sub_src=expressway"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoExpressway">&nbsp;</i>
                    Expressway
                  </a>
                </li>
              </ul>
            </li>
            <li className="userAccountCol quickTools">
              <ul>
                <li className="quickToolsHead">Quick Tools</li>
                <li>
                  <a
                    href="/account?next=cancel&amp;src=qtct&amp;sub_src=cancellations"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoCancel">&nbsp;</i>
                    Cancellations
                  </a>
                </li>
                <li>
                  <a
                    href="/account?next=amend&amp;src=qtct&amp;sub_src=change_flight"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoChange">&nbsp;</i>
                    Change flight
                  </a>
                </li>
                <li className="separator" />
                <li>
                  <a
                    href="/ticket?src=qtct&amp;sub_src=print_ticket"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoTicket">&nbsp;</i>
                    Print ticket
                  </a>
                </li>
                <li>
                  <a
                    href="/voucher?src=qtct&amp;sub_src=print_hotel_voucher"
                    className="forceHttps"
                    appref="true"
                    onMouseDown={e => {
                      console.log('onClick')
                      e.target.preventDefault()
                      e.target.stopPropagation()
                    }}
                  >
                    <i className="iconSprite icoHotelVoucher">&nbsp;</i>
                    Print hotel voucher
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li className="miscLinks">
          <ul>
            <li>
              <a
                href="/account/profile?src=qtct&amp;sub_src=profile"
                className="forceHttps"
                appref="true"
                onMouseDown={e => {
                  console.log('onClick')
                  e.target.preventDefault()
                  e.target.stopPropagation()
                }}
              >
                Profile
              </a>
            </li>
            <li>
              <a
                href="/account/settings?src=qtct&amp;sub_src=settings"
                className="forceHttps"
                appref="true"
                onMouseDown={e => {
                  console.log('onClick')
                  e.target.preventDefault()
                  e.target.stopPropagation()
                }}
              >
                Settings
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0);"
                className="forceHttps"
                id="global_signout"
                onMouseDown={e => {
                  console.log('onClick')
                  e.target.preventDefault()
                  e.target.stopPropagation()
                }}
              >
                Sign out
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <Login
        page={page}
        isShowing={isShowing}
        toggle={toggle}
        handleIsShowing={handleIsShowing}
      />
    </>
  )
}

export default LoggedoutProfileDropdown
